/**
 * FE mirror of the BE canonical feature registry.
 * Codes MUST stay in sync with backend-go/internal/features/registry.go.
 * Each entry carries i18n key references — actual strings live in
 * src/i18n/locales/{vi,en}/system-admin/features.json.
 */
export const CANONICAL_FEATURES = [
  {
    code: "knowledge_base",
    labelKey: "features.knowledge_base.label",
    descKey: "features.knowledge_base.desc",
  },
  {
    code: "workflows",
    labelKey: "features.workflows.label",
    descKey: "features.workflows.desc",
  },
  {
    code: "agents",
    labelKey: "features.agents.label",
    descKey: "features.agents.desc",
  },
  {
    code: "kg",
    labelKey: "features.kg.label",
    descKey: "features.kg.desc",
  },
  {
    code: "mcp_workflow_authoring",
    labelKey: "features.mcp_workflow_authoring.label",
    descKey: "features.mcp_workflow_authoring.desc",
  },
  {
    code: "mcp_raw_sql_execute",
    labelKey: "features.mcp_raw_sql_execute.label",
    descKey: "features.mcp_raw_sql_execute.desc",
  },
  {
    code: "workflow_http_nodes",
    labelKey: "features.workflow_http_nodes.label",
    descKey: "features.workflow_http_nodes.desc",
  },
] as const;

export type FeatureCode = (typeof CANONICAL_FEATURES)[number]["code"];

export const DEFAULT_ENABLED_FEATURES: FeatureCode[] = ["knowledge_base", "workflows", "agents", "kg"];
